import { createSelector } from 'reselect'
import { emptyObj } from 'util/objects'
import { selectCurrentUserIsAdminOrOwner } from 'ducks/currentUser/selectors/base'
import {
  toInboxesPage,
  toCannedRepliesPage,
} from 'subapps/settings/actions/redirect'
import { selectIsUnread } from './realtime'

export const selectIsChangeInboxMenuOpen = state =>
  !!state.menus.changeInboxOpen

export const selectIsMoreTicketOptionsMenuOpen = state =>
  !!state.menus.moreTicketOptionsOpen

export const selectMenuNoticeCounts = () => emptyObj

export const selectMenuAlerts = createSelector(selectIsUnread, unread => ({
  'Live Chat': unread,
}))

export const selectSettingsLandingPageAction = createSelector(
  selectCurrentUserIsAdminOrOwner,
  isAdminOrOwner => (isAdminOrOwner ? toInboxesPage : toCannedRepliesPage)
)
